﻿import { Trpdbvoucher } from "../Trpdbvoucher";
import { Trpdbvoucherdetail } from "../Trpdbvoucherdetail";
import { VehicleExpense } from "./VehicleExpense";

export class VExpense {
	public Voucher: Trpdbvoucher | undefined;
	public VoucherDetail: Trpdbvoucherdetail[] = [];
	public VehicleExpenseList: VehicleExpense[] = [];
}
